import { SearchBox } from 'office-ui-fabric-react';
import {
  INVITATIONSOURCETYPE_CSV,
  INVITATIONSOURCETYPE_EXCEL,
  INVITATIONSOURCETYPE_INVITATION_GROUP,
  INVITATIONSOURCETYPE_NONE,
  INVITATIONSOURCETYPE_PERSONAL,
} from '../../../../../../../constants/api';
import { getAttr } from '../../../../../../../features/helpers/apiHelpers';
import { toTitleCase } from '../../../../../../../utilities/capitalizeFirstletter';

const INVITATION_SOURCE_TYPE_MAPPING = {
  [INVITATIONSOURCETYPE_NONE]: 'NONE',
  [INVITATIONSOURCETYPE_PERSONAL]: 'PERSONAL',
  [INVITATIONSOURCETYPE_INVITATION_GROUP]: 'INVITATION_GROUP',
  [INVITATIONSOURCETYPE_CSV]: 'CSV',
  [INVITATIONSOURCETYPE_EXCEL]: 'EXCEL',
};

function getIconForSourceType(type) {
  switch (type) {
    case 'CSV':
      return 'Upload';
    case 'EXCEL':
      return 'ExcelLogo';
    case 'PERSONAL':
      return 'AddFriend';
    case 'INVITATION_GROUP':
      return 'Group';
    default:
      return 'Document';
  }
}

export function commandBarItems(
  translator,
  invitationSources,
  onInvitationSourceClick,
  onEditInvitationClick,
) {
  const editInvitationItem = {
    key: 'editInvitation',
    text: translator(
      'pages.createHearing.createHearingInvitations.invitationCommandBar.editInvitation',
    ),
    iconProps: {
      iconName: 'Edit',
    },
    onClick: onEditInvitationClick,
    buttonStyles,
  };

  if (!Array.isArray(invitationSources) || invitationSources.length === 0) {
    return [editInvitationItem];
  }

  // Group invitation sources by their type
  const sourcesByInvitationSourceType = invitationSources.reduce(
    (acc, source) => {
      const invitationSourceType = getAttr(source, 'invitationSourceType');
      const invitationSourceAsEnum =
        INVITATION_SOURCE_TYPE_MAPPING[invitationSourceType];
      if (!acc[invitationSourceAsEnum]) {
        acc[invitationSourceAsEnum] = [];
      }
      acc[invitationSourceAsEnum].push(source);
      return acc;
    },
    {},
  );

  const invitationSourceItems = Object.entries(
    sourcesByInvitationSourceType,
  ).map(([type, sources]) => {
    // If there are multiple sources of a given type, create sub-items
    if (sources.length > 1) {
      const baseItem = {
        key: type,
        text: toTitleCase(type),
        iconProps: { iconName: getIconForSourceType(type) },
        buttonStyles,
        subMenuProps: {
          items: sources.map((source) => ({
            key: getAttr(source, 'name'),
            text: getAttr(source, 'name'),
            onClick: () => onInvitationSourceClick(source),
          })),
        },
      };
      return baseItem;
    } else {
      // Single source of a given type
      const source = sources[0];
      const baseItem = {
        key: getAttr(source, 'name'),
        text: getAttr(source, 'name'),
        iconProps: { iconName: getIconForSourceType(type) },
        buttonStyles,
        onClick: () => onInvitationSourceClick(source),
      };
      return baseItem;
    }
  });

  return [...invitationSourceItems, editInvitationItem];
}

export function farItems(translator, titleFilter, handleTitleFilterChange) {
  return [
    {
      key: 'filter',
      name: translator(
        'pages.createHearing.createHearingInvitations.invitationCommandBar.filterText',
      ),
      onRender: () => (
        <SearchBox
          styles={{ root: { width: 200, marginTop: '6px' } }}
          onChange={(_, value) => handleTitleFilterChange(value)}
          placeholder={translator(
            'pages.createHearing.createHearingInvitations.invitationCommandBar.filterText',
          )}
          value={titleFilter || ''}
          ariaLabel={translator('ariaLabel.pageHeaderSearch')}
        />
      ),
    },
  ];
}

const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
